import React from 'react';
import { Bar } from 'react-chartjs-2';
import 'chart.js/auto';
import CalendarComp from '../../CalendarComp/CalendarComp';
import PaymentEarning from '../Earning/PaymentEarning';

// Helper function to generate dates for the current month
const getDaysInMonth = (month, year) => {
  const date = new Date(year, month, 1);
  const days = [];
  while (date.getMonth() === month) {
    days.push(new Date(date).toISOString().split('T')[0]); // Format as YYYY-MM-DD
    date.setDate(date.getDate() + 1);
  }
  return days;
};

const getDaysInWeek = (date) => {
  const startOfWeek = new Date(date);
  startOfWeek.setDate(date.getDate() - date.getDay()); // Set to Sunday of the week
  
  const days = [];
  for (let i = 1; i <= 7; i++) {
    const currentDate = new Date(startOfWeek);
    currentDate.setDate(startOfWeek.getDate() + i);
    days.push(currentDate.toISOString().split('T')[0]); // Format as YYYY-MM-DD
  }
  
  return days;
};

const EarninChart = ({data,progressData,handleFilter}) => { 
  const now = new Date();
  // const daysInMonth = getDaysInMonth(now.getMonth(), now.getFullYear());
  const daysInWeek = getDaysInWeek(now);

  

  // Example data for each day of the current month for different categories
  const generateRandomData = () => Array(daysInWeek.length).fill().map(() => Math.floor(Math.random() * 100));

  const dataCancelledByAdmin = generateRandomData();
 

  // console.log("dataCancelledByVendor",dataCancelledByAdmin);


let date=[], totalOrders=[],totalOrderPayment=[],adminEarn=[],storeEarn=[],totalDeliveryPayment=[], deliverymanEarn=[]

  data?.forEach((d,i)=>{
    date.push(d.date)
    totalOrders.push(d.totalOrders)
    totalOrderPayment.push(d.totalOrderPayment)    
    storeEarn.push(d.storeEarn)
    adminEarn.push(d.adminEarn)
    totalDeliveryPayment.push(d.totalDeliveryPayment)
    deliverymanEarn.push(d.deliverymanEarn)
})
  
  const BarData = {
    labels: date,
    datasets: [
      {
        label: 'Total Order',
        backgroundColor: 'rgba(255,99,132,0.4)',
        borderColor: 'rgba(255,99,132,1)',
        borderWidth: 1,
        hoverBackgroundColor: 'rgba(255,99,132,0.6)',
        hoverBorderColor: 'rgba(255,99,132,1)',
        data: totalOrders,
      },
      {
        label: 'Total Payments',
        backgroundColor: 'rgba(54,162,235,0.4)',
        borderColor: 'rgba(54,162,235,1)',
        borderWidth: 1,
        hoverBackgroundColor: 'rgba(54,162,235,0.6)',
        hoverBorderColor: 'rgba(54,162,235,1)',
        data: totalOrderPayment,
      },
      {
        label: 'Vendor Earnings',
        backgroundColor: 'rgba(75,192,192,0.4)',
        borderColor: 'rgba(75,192,192,1)',
        borderWidth: 1,
        hoverBackgroundColor: 'rgba(75,192,192,0.6)',
        hoverBorderColor: 'rgba(75,192,192,1)',
        data: storeEarn,
      },
      {
        label: 'Admin Earnings',
        backgroundColor: 'rgb(0, 31, 61,0.6 )',
        borderColor: 'rgba(75,192,192,1)',
        borderWidth: 1,
        hoverBackgroundColor: 'rgb(0, 31, 61,0.9 )',
        hoverBorderColor: 'rgba(75,192,192,1)',
        data: adminEarn,
      },
      // {
      //   label: 'Deliveryman Earnings',
      //   backgroundColor: 'rgba(153,102,255,0.4)',
      //   borderColor: 'rgba(153,102,255,1)',
      //   borderWidth: 1,
      //   hoverBackgroundColor: 'rgba(153,102,255,0.6)',
      //   hoverBorderColor: 'rgba(153,102,255,1)',
      //   data: deliverymanEarn,
      // },
      // {
      //   label: 'Total Delivery Payment',
      //   backgroundColor: 'rgba(255,206,86,0.4)',
      //   borderColor: 'rgba(255,206,86,1)',
      //   borderWidth: 1,
      //   hoverBackgroundColor: 'rgba(255,206,86,0.6)',
      //   hoverBorderColor: 'rgba(255,206,86,1)',
      //   data: totalDeliveryPayment,
      // },
    
    ],
  };

  const options = {
    maintainAspectRatio: false,
    scales: {
      y: {
        beginAtZero: true,
      },
      x: {
        ticks: {
          maxTicksLimit: 15, // Adjust this value for better readability if needed
        },
      },
    },
  };


  console.log("ProgressData",progressData)

  

  return (
    <>
    <div className='flex gap-2 border rounded-md shadow-[0px_0px_15px_0px_rgba(0,0,0,0.2)] mt-5 flex-col p-5'>
        <div className='flex items-center gap-2'>
        <h1 className='text-[1rem] font-bold'>Earning Bar Chart</h1>
        <CalendarComp view="date" sx={{borderRadius: "20px" }} handleFilter={handleFilter} />
        </div>
        <div className={`flex justify-between flex-wrap gap-6 my-2`}>
          {progressData.map(({ left, right }, i) => (<PaymentEarning key={i} left={left} right={right} />))}
        </div>
    <div className="chart-container  " style={{ position: 'relative', height: '400px', width: '100%' }}>

      <Bar data={BarData} options={options} />
    </div>
        </div>
    </>
  );
};

export default EarninChart;
